<template>
  <div class="fixed bottom-0 left-0 w-full edit-google-slide">
    <aha-button
      variant="base"
      class="w-full h-10"
      :disabled="submitting"
      :submitting="submitting"
      @click="clickToEditSlide"
    >
      <img src="@/assets/images/google-slides/icon-edit.svg" alt="" class="mr-2"> Edit this slide
    </aha-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import GoogleSlideService from '@/services/google-slide'

const backgroundImage = require('@/assets/images/google-slides/tutorial-banner.svg')

export default {
  components: {
  },
  data() {
    return {
      backgroundImage,
      submitting: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      googleSlideActiveId: (state) => state.googleSlideActiveId,
    }),
  },
  methods: {
    ...mapActions([
      'setPresentationAction',
      'setSlideActiveAction',
      'patchPresentationAction',
      'updateSlideActiveAction',
    ]),
    async clickToEditSlide() {
      this.submitting = true
      const googleSlideActiveId = await GoogleSlideService.getGoogleSlideActiveId()
      const index = this.presentation.slides.findIndex(
        (slide) => slide.googleSlide && slide.googleSlide.googleSlideId === googleSlideActiveId,
      )
      if (index !== -1) {
        this.$store.state.googleSlideActiveId = this.presentation.slides[index].id
        this.setSlideActiveAction(this.presentation.slides[index])
      }
      this.submitting = false
    },
  },
}
</script>

<style lang="scss" scoped>

.edit-google-slide {
  background-color: #fff;
  border-top: 1px solid #D3D7E1;
  padding: 16px 8px;

  aha-button {
    height: 36px;

    img {
      margin-right: 4px;
    }
  }
}
</style>
